import { Grid, TextField } from "@mui/material";

const CampoTextoSamsic = ({
  label,
  name,
  value,
  onChange,
  xs = 6,
  required = false,
  disabled = false,
}) => {
  return (
    <Grid item xs={xs}>
      <TextField
        label={label}
        name={name}
        value={value}
        onChange={onChange}
        fullWidth
        required={required}
        disabled={disabled}
      />
    </Grid>
  );
};

export default CampoTextoSamsic;
